import { useMemo, useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viBel, viCheck, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddDistinctiveRingtoneItem({ distinctiveRingtone, user, dispatch }) {
  const [pending, setPending] = useState(false);

  const isActive = useMemo(() => {
    return user.distinctiveRingtones.find((ringtone) => ringtone.id === distinctiveRingtone.id);
  }, [distinctiveRingtone.id, user.distinctiveRingtones]);

  const isDisabled = useMemo(() => {
    return user.distinctiveRingtones.length >= 6 && !isActive;
  }, [isActive, user.distinctiveRingtones.length]);

  const addDistinctiveRingtone = async () => {
    setPending(true);

    if (!isActive) {
      Promise.resolve(Api.postUserDistinctiveRingtone(user, distinctiveRingtone))
        .then(() => {
          dispatch({ type: "addDistinctiveRingtone", distinctiveRingtone });

          setPending(false);
        })
        .catch(() => setPending(false));
    } else {
      Promise.resolve(Api.deleteUserDistinctiveRingtone(user, distinctiveRingtone))
        .then(() => {
          dispatch({ type: "removeDistinctiveRingtone", distinctiveRingtone });

          setPending(false);
        })
        .catch(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton
        key={distinctiveRingtone.id}
        onClick={() => addDistinctiveRingtone()}
        disabled={pending || isDisabled}
        sx={{ minHeight: 44 }}
      >
        <ListItemAvatar>
          <Avatar text={distinctiveRingtone.name} px={24} icon={viBel} />
        </ListItemAvatar>
        <ListItemText primary={distinctiveRingtone.name} />
        {(isActive || pending) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddDistinctiveRingtoneItem.propTypes = {
  distinctiveRingtone: PropTypes.object,
  user: PropTypes.object,
  dispatch: PropTypes.func,
};

export default AddDistinctiveRingtoneItem;
